jQuery(document).ready(function ($) {
    var noRightTemplate = '<li class="fc-card active visible no-right">\
<div>\
<p>You have not marked any cards as <em>right<\/em>.<br> To mark a card as <em>right<\/em>, click the <span class="icon"><!-- --><\/span> at the bottom of any card.<\/p>\
<\/div>\
<\/li>';

    var noWrongTemplate = '<li class="fc-card active visible no-wrong">\
<div>\
	<p>You have not marked any cards as <em>wrong<\/em>.<br> To mark a card as <em>wrong<\/em>, click the <span class="icon"><!-- --><\/span> at the bottom of any card.<\/p>\
		<\/div>\
		<\/li>';

    $('.fc-cards').on('click',function(e){
        e.preventDefault();

        if ($(e.target).hasClass('fc-mark') || $(e.target).parents('.fc-mark').length > 0) {
            return;
        }

        let card = $(e.target).closest('.fc-card.active .scene>.card');

        if(!$('.fc-board').hasClass('both')){
            $(card).toggleClass('is-flipped');
            if(!$('body').hasClass('study')) {
                $('.fc-tip.definition').toggle();
                $('.fc-tip.term').toggle();
            }
        }
    });

    /* Next / Previous */
    $('#fc-next, #fc-pagin-next').click(function(e) {
        e.preventDefault();
        let currentState = $('.fc-tabs .active').attr('id').replace('fc-tab-', '');
        if ($(this).hasClass('disabled')) return;
        let curIndex = parseInt($('.fc-card.next-card').attr('data-index'));
        if(isNaN(curIndex) || curIndex>0){
            $('#fc-previous, #fc-pagin-prev').removeClass('disabled')
        }
        if ($('.fc-board').hasClass('term') && $('.fc-board').hasClass('flip')) var termFlag = true;
        if ($('.fc-board').hasClass('definition') && $('.fc-board').hasClass('flip')) var defFlag = true;
        $('.fc-card.prev-card').removeClass('prev-card');
        $('.fc-card.active').removeClass('active').addClass('prev-card').css({'visibility': 'hidden'}).find('.card').removeClass('is-flipped');
        if($('.fc-card.next-card').hasClass('end')){
            $('#fc-next, #fc-pagin-next').addClass('disabled');
        }else if (currentState == 2 || currentState == 3){
            let markType;
            if (currentState == 2) {
                markType = 'wrong';
            } else if (currentState == 3) {
                markType = 'right';
            }
            let markedCards = $('.fc-card[data-mark="' + markType + '"]');
            $('#fc-pagination>span').text(Math.min(curIndex+1,($('.fc-card').length-1)) + ' of ' +(markedCards.length));
        } else {
            $('#fc-pagination>span').text(Math.min(curIndex+1,($('.fc-card').length-1)) + ' of ' +($('.fc-card').length-1))
        }
        $('.fc-card.next-card').css({'visibility': 'visible'}).removeClass('next-card').addClass('active');
        $('.fc-card[data-index="' + (curIndex + 1) + '"]').removeClass('prev-card').addClass('next-card');

    });
    $('#fc-previous, #fc-pagin-prev').click(function(e) {
        e.preventDefault();
        let currentState = $('.fc-tabs .active').attr('id').replace('fc-tab-', '');
        if ($(this).hasClass('disabled')) return;
        let newIndex = parseInt($('.fc-card.prev-card').attr('data-index'));

        $('#fc-next, #fc-pagin-next').removeClass('disabled')

        if ($('.fc-board').hasClass('term')) var termFlag = true;
        if ($('.fc-board').hasClass('definition')) var defFlag = true;
        $('.fc-card.next-card').removeClass('next-card');
        $('.fc-card.active').removeClass('active').addClass('next-card').css({'visibility': 'hidden'}).find('.card').removeClass('is-flipped');
        if($('.fc-card.prev-card').attr('data-index')==0){
            $('#fc-previous, #fc-pagin-prev').addClass('disabled');
        }

        $('.fc-card.prev-card').css({'visibility': 'visible'}).removeClass('prev-card').addClass('active');
        $('.fc-card[data-index="' + (newIndex -1) + '"]').removeClass('next-card').addClass('prev-card');

        let markType;
        if (currentState == 2) {
            markType = 'wrong';
        } else if (currentState == 3) {
            markType = 'right';
        }
        let markedCards = $('.fc-card[data-mark="' + markType + '"]');

        if(currentState == 2 || currentState == 3){
            $('#fc-pagination>span').text(Math.max(newIndex+1,1) + ' of ' +(markedCards.length));
        } else {
            $('#fc-pagination>span').text(Math.max(newIndex+1,1) + ' of ' +($('.fc-card').length-1))
        }
    });

    $('.end-card-start-over').on('click', function(e) {
        e.preventDefault();

        var currentState = $('.fc-tabs .active').attr('id').replace('fc-tab-', '');

        if (currentState == 1) {
            $('.fc-card').each(function (index) {
                $(this).removeClass('next-card').removeClass('prev-card').removeClass('active').css({'visibility': 'hidden'})
                if (index === 0) {
                    $(this).addClass('active').css({'visibility': 'visible'});
                } else if (index === 1) {
                    $(this).addClass('next-card');
                }

            });
            $('#fc-previous, #fc-pagin-prev').addClass('disabled');
            $('#fc-next, #fc-pagin-next').removeClass('disabled');
            $('#fc-pagination span').html('1 of ' + ($('.fc-card').length -1));
            return;
        }

        var markType = currentState == 2 ? 'wrong' : 'right';

        $('.fc-card').css({'visibility': 'hidden'}).removeClass('next-card prev-card active');
        var markedCards = $('.fc-card[data-mark="' + markType + '"]');

        markedCards.each(function(index) {

            if(index === 0){
                $(this).addClass('active').css({'visibility': 'visible'});
            }

            else if(index === 1){
                $(this).addClass('next-card');
            }
        });

        $('#fc-previous, #fc-pagin-prev').addClass('disabled');
        if(markedCards.length <= 1) {
            $('#fc-next, #fc-pagin-next').addClass('disabled');
        } else {
            $('#fc-next, #fc-pagin-next').removeClass('disabled');
        }
        resetCards();
    });


    $('#fc-show-cont').on('click','li',function(e){
        let show = $(this).attr('data-value');
        side = show
        $('.fc-board').removeClass('definition').removeClass('both').removeClass('term').addClass(show);
        $('.fc-term-definition').removeClass('is-flipped');
        if(show==='term' || show==='definition'){
            $('.fc-term-definition').addClass('card');
            $('.fc-term-definition .both').hide();
            $('.card__face--front').show();
            $('.card__face--back').show();
            if(show==='term'){
                $('.fc-tip.definition').hide();
                $('.fc-tip.term').show();
            }else{
                $('.fc-tip.definition').show();
                $('.fc-tip.term').hide();
            }
        }else if(show==='both'){
            $('.fc-term-definition').removeClass('card')
            $('.fc-term-definition .both').show();
            $('.card__face--front').hide();
            $('.card__face--back').hide();
            $('.fc-tip.definition').hide();
            $('.fc-tip.term').hide();

        }
        $('#fc-show-cont ul li').removeClass('active');
        $(this).addClass('active');
    })

    $('#fc-study-on').on('click',function(e){
       e.preventDefault();

        $('body').addClass('study');
        $('.hero, header, .lightgrey-bg, .download-author, .upgrade-to-proplus, .publications, #lower-promo, #footer, #mark-complete, #topic-outline-mini, #footer-search, .achievements, .fc-study-hide').fadeOut();
        $('#fc-study-control span').removeClass('active');
        $(this).addClass('active')
    });
    $('#fc-study-off').on('click',function(e){
        e.preventDefault();
        let showBoth = $('.fc-board').hasClass('both');
        let showTerm = $('.fc-board').hasClass('term');
        let showClass = showTerm?'term':'definition';

        $('body').removeClass('study');
        $('.hero, header, .lightgrey-bg, .download-author, .upgrade-to-proplus, .publications, #lower-promo, #footer, #mark-complete, #topic-outline-mini, #footer-search, .achievements, .fc-study-hide').fadeIn();
        $('#fc-study-control span').removeClass('active');
        $('.fc-tip:visible').hide();
        if(!showBoth) {
            $('.fc-tip.' + showClass).show()
        }
        $(this).addClass('active');
        $([document.documentElement, document.body]).animate({
            scrollTop: $(".fc-container").offset().top-200
        }, 300);
    });
    let startPos = {x:0,y:0};
    let swipeThreshold = 30;
    let swipeVerticalThreshold = 100;
    $('.fc-cards').on('touchstart', function(e){
        startPos.x = e.originalEvent.touches[0].screenX;
        startPos.y = e.originalEvent.touches[0].screenY;
    });

    $('.fc-cards').on('touchend', function(e){

        if( Math.abs(startPos.x - e.originalEvent.changedTouches[0].screenX) >= swipeThreshold && Math.abs(startPos.y - e.originalEvent.changedTouches[0].screenY) <= swipeVerticalThreshold){
            const dir = startPos.x - e.originalEvent.changedTouches[0].screenX > 0 ? 'left' : 'right';
            if (dir == "left") {
                $('#fc-next').trigger('click')
            }
            if (dir == "right") {
                $('#fc-previous').trigger('click')
            }
            e.stopImmediatePropagation();
            e.preventDefault();
        }
    });
    $('.fc-cards').on('touchend, click', '.fc-answer-link' ,function(e){
        if(e.originalEvent.changedTouches && (Math.abs(startPos.x - e.originalEvent.changedTouches[0].screenX) >= swipeThreshold || Math.abs(startPos.y - e.originalEvent.changedTouches[0].screenY) >= swipeVerticalThreshold)){
            return;
        }
        e.preventDefault();
        e.stopImmediatePropagation();
        const currentAnswer = $(this).closest('.fc-card').attr('data-mark');
        $(this).closest('.fc-card').removeAttr('data-mark').find('.fc-mark').removeClass('right').removeClass('wrong')
        $(this).closest('.fc-card').attr('data-mark','wrong').find('.right-text').text('Mark as right')
        $(this).closest('.fc-card').attr('data-mark','wrong').find('.wrong-text').text('Mark as wrong')
        let postData = {
            answer:$(this).attr('data-answer'),
            flashcard_topic_id:$(this).attr('data-topic-id'),
            flashcard_id:$(this).attr('data-card-id'),
        }


        if(currentAnswer === postData.answer){
            postData.answer = '';
        }else if($(this).attr('data-answer') === 'wrong'){
            $(this).closest('.fc-card').attr('data-mark','wrong').find('.fc-mark').addClass('wrong')
            $(this).closest('.fc-card').attr('data-mark','wrong').find('.wrong-text').text('Marked as wrong')
            $(this).closest('.fc-card').attr('data-mark','wrong').find('.right-text').text('Mark as right')
        }else{
            $(this).closest('.fc-card').attr('data-mark','wrong').find('.fc-mark').addClass('right')
            $(this).closest('.fc-card').attr('data-mark','wrong').find('.wrong-text').text('Mark as wrong')
            $(this).closest('.fc-card').attr('data-mark','wrong').find('.right-text').text('Marked as right')
        }

        $.post(accountingcoach.ajax_url +'?action=ac_record_flashcard_answer_ajax',postData).then(function(res){
            $('#wrong-count-number').text('('+res.wrong_answers.length+')')
            $('#right-count-number').text('('+res.right_answers.length+')')
            $('.fc-card').each(function(){$(this).removeAttr('data-mark').find('.fc-mark').removeClass('right').removeClass('wrong')})
            res.wrong_answers.forEach(function(id){
                $('.fc-card[data-card-id="'+id+'"]').attr('data-mark','wrong').find('.fc-mark').addClass('wrong');
            })
            res.right_answers.forEach(function(id){
                $('.fc-card[data-card-id="'+id+'"]').attr('data-mark','right').find('.fc-mark').addClass('right');
            })
        }).catch(function(e){
            console.log(e);
            }
        )
    });
    var shown = 1;
    var side = 'term';
    $('.fc-tabs').on('click', 'a', function(e) {
        e.preventDefault();
        var $parent = $(this).parent();
        if($parent.hasClass('active')) return;
        $('.fc-tabs li').removeClass('active');
        $parent.addClass('active');
        var state = parseInt($parent.attr('id').replace('fc-tab-', ''));
        shown = state;
        $('.fc-card').removeClass('visible');
        $('.fc-card.no-right, .fc-card.no-wrong').remove();
        $('.fc-card').addClass('no-transition').removeClass('visible').removeClass('active').removeClass('next-card').removeClass('prev-card').removeAttr('style');
        if(state == 1) {
            $('a.end-card-view-all-link').hide();
            $('.fc-card').addClass('visible');
        }
        else if(state == 2) {
            $('a.end-card-view-all-link').css({'display' : 'inline-block'});
            if($('.fc-card[data-mark="wrong"]').length) {
                $('.fc-card[data-mark="wrong"]').addClass('visible');
                $('.fc-card.end').addClass('visible');
            }
            else {
                showEmptyCard();
            }

        }
        else if(state == 3) {
            $('a.end-card-view-all-link').css({'display' : 'inline-block'});
            if($('.fc-card[data-mark="right"]').length) {
                $('.fc-card[data-mark="right"]').addClass('visible');
                $('.fc-card.end').addClass('visible');

            } else {
                showEmptyCard();
            }

        }
        resetCards();
    });

    function switchToViewCards() {
        $('.fc-tabs li').removeClass('active');
        var viewCardsTab = $('#fc-tab-1');
        viewCardsTab.addClass('active');
        var state = 1;
        shown = state;
        $('.fc-card').removeClass('visible');
        $('.fc-card.no-right, .fc-card.no-wrong').remove();
        $('.fc-card').addClass('no-transition').removeClass('visible').removeClass('active').removeClass('next-card').removeClass('prev-card').removeAttr('style');
        $('a.end-card-view-all-link').hide();
        $('.fc-card').addClass('visible');
        resetCards();
    }

    $('a.end-card-view-all-link').on('click', function(e) {
        e.preventDefault();
        switchToViewCards();
    });

    function showEmptyCard() {
        var $template = shown == 2 ? noWrongTemplate : noRightTemplate;
        $('.fc-cards').append($template);
    }

    function resetCards (currentIndex) {
        $('.fc-card').addClass('no-transition').removeClass('active').removeClass('next-card').removeClass('prev-card').removeAttr('style');
        $('.fc-card').data('index', '-1');
        $('.fc-card').attr('data-index', '-1');
        $('.fc-board').removeClass('flip');
        $('.fc-card.visible').each(function( cardIndex ) {
            if(!currentIndex) {
                if(cardIndex == 0) $(this).addClass('active');
                else if(cardIndex == 1) $(this).addClass('next-card');
            } else {
                if(cardIndex == currentIndex) $(this).addClass('active');
                if(cardIndex == (currentIndex + 1)) $(this).addClass('next-card');
                if(cardIndex == (currentIndex - 1)) $(this).addClass('prev-card');
            }
            $(this).data('index', cardIndex);
            $(this).attr('data-index', cardIndex);
        });
        $('.fc-card').removeClass('no-transition');
        setCardNavigation();
    }

    function setCardNavigation() {
        var cardCount = $('.fc-card.visible').length - 1; //shuffled ? $('.fc-card.visible').length : ($('.fc-card.visible').length - 1)
        $('.fc-board').removeClass('flip');
        if(parseInt($('.fc-card.active').data('index')) == 0)
            $('#fc-previous, #fc-pagin-prev').addClass('disabled');
        else $('#fc-previous, #fc-pagin-prev').removeClass('disabled');
        if(parseInt($('.fc-card.active').data('index')) == ($('.fc-card.visible').length - 1))
            $('#fc-next, #fc-pagin-next').addClass('disabled');
        else $('#fc-next, #fc-pagin-next').removeClass('disabled');
        var currentInt = $('.fc-card.active').hasClass('end') ? cardCount : (parseInt($('.fc-card.active').attr('data-index')) + 1);

        if($('.fc-card.active').hasClass('no-right') ||  $('.fc-card.visible').hasClass('no-wrong')) {
            currentInt = 0;
            cardCount = 0;
        }
        if($('.fc-card.active').hasClass('end'))
            $('#fc-pagination span').html('The End');
        else
            $('#fc-pagination span').html(currentInt + ' of ' + cardCount);
        if($('.fc-card.active').hasClass('end') || $('.fc-card.active').hasClass('no-right') || $('.fc-card.active').hasClass('no-wrong')) $('.fc-tip').hide();
        else {
            $('.fc-tip.swipe').attr('style', '');
            if(side == 'definition') {
                $('.fc-tip.term').hide();
                $('.fc-tip.definition').show();
            }
            else if(side == 'term') {
                $('.fc-tip.definition').hide();
                $('.fc-tip.term').show();
            }
        }

    }

    $('#fc-clear-all').on('click',function(e){
        e.preventDefault();
        let postData = {
            flashcard_topic_id:$(this).attr('data-topic-id')
        }
        $.post(accountingcoach.ajax_url +'?action=ac_clear_flashcard_answers_ajax',postData).then(function(res){
            $('#wrong-count-number').text('(0)')
            $('#right-count-number').text('(0)')
            $('.fc-card').each(function(){
                $(this).attr('data-mark','').find('.fc-mark').removeClass('right').removeClass('wrong');
            })

        }).catch(function(e){
                console.log(e);
            }
        )
    })

    let hotkeysActive = false;

    $('#fc-keyboard-on').on('click',function(e){
        e.preventDefault();
        hotkeysActive = true;
        $('#fc-keyboard-control span').removeClass('active');
        $(this).addClass('active')
     });
     $('#fc-keyboard-off').on('click',function(e){
         e.preventDefault();
         hotkeysActive = false;
         $('#fc-keyboard-control span').removeClass('active');
         $(this).addClass('active');
    });

    $(document).on('keydown', function(e) {
        if (hotkeysActive) {
            switch(e.which) {
                case 37:
                    $('#fc-previous').trigger('click');
                    break;

                case 39:
                    $('#fc-next').trigger('click');
                    break;

                case 38:
                    e.preventDefault();
                    let card = $('.fc-card.active .scene>.card');
                    if(!$('.fc-board').hasClass('both')){
                        $(card).toggleClass('is-flipped');
                        if(!$('body').hasClass('study')) {
                            $('.fc-tip.definition').toggle();
                            $('.fc-tip.term').toggle();
                        }
                    }
                    break;

                default: return; // Exit this handler for other keys
            }
            e.preventDefault(); // Prevent default behavior for the handled keys
        }
    });
});

